import React, { useState, useEffect } from 'react';
import { SW_UPDATE_EVENT, applyUpdate } from '../../serviceWorkerRegistration';
import './Pwa.css';

/**
 * Toast affiché quand une nouvelle version de l'app est prête (service worker
 * en attente). L'utilisateur choisit quand recharger — jamais de reload forcé
 * pendant une consultation.
 */
const UpdateToast: React.FC = () => {
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null);

  useEffect(() => {
    const onUpdate = (event: Event) => {
      const custom = event as CustomEvent<ServiceWorkerRegistration>;
      if (custom.detail) setRegistration(custom.detail);
    };
    window.addEventListener(SW_UPDATE_EVENT, onUpdate);
    return () => window.removeEventListener(SW_UPDATE_EVENT, onUpdate);
  }, []);

  if (!registration) return null;

  return (
    <div className='pwa-update-toast' role='status'>
      <i className='material-icons'>system_update</i>
      <span>Nouvelle version disponible</span>
      <button type='button' className='pwa-install-btn' onClick={() => applyUpdate(registration)}>
        Actualiser
      </button>
      <button
        type='button'
        className='pwa-install-close'
        onClick={() => setRegistration(null)}
        aria-label='Plus tard'
      >
        <i className='material-icons'>close</i>
      </button>
    </div>
  );
};

export default UpdateToast;
